import { render } from "./PostDetailDialog.vue?vue&type=template&id=01a39ca0&scoped=true"
import script from "./PostDetailDialog.vue?vue&type=script&lang=js"
export * from "./PostDetailDialog.vue?vue&type=script&lang=js"

import "./PostDetailDialog.vue?vue&type=style&index=0&id=01a39ca0&scoped=true&lang=css"
import "./PostDetailDialog.vue?vue&type=style&index=1&id=01a39ca0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a39ca0"]])

export default __exports__